<article class="flex flex-col gap-y-4 rounded-xl border border-border bg-card p-5 shadow-sm">
  <header class="flex flex-col gap-y-3 sm:flex-row sm:items-start sm:justify-between sm:gap-x-5">
    <div class="flex flex-col gap-y-0.5">
      <h2 class="m-0 text-lg font-semibold text-primary">Daily performance</h2>
      <p class="m-0 text-sm text-secondary">{{ note() }}</p>
    </div>

    <nav
      aria-label="Chart metric"
      class="flex shrink-0 flex-row items-center gap-x-1 rounded-full bg-muted p-1"
    >
      @for (option of metricOptions; track option.key) {
        <button
          type="button"
          (click)="selectMetric(option.key)"
          [attr.aria-current]="metric() === option.key ? 'true' : null"
          class="cursor-pointer rounded-full px-3 py-1.5 text-sm font-semibold transition-colors"
          [class]="getSegmentClass(option.key)"
        >
          {{ option.label }}
        </button>
      }
    </nav>
  </header>

  @if (loadState() === 'loading') {
    <div aria-busy="true" aria-label="Loading daily performance" class="flex h-52 items-end gap-x-2">
      @for (bar of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]; track bar) {
        <div
          class="flex-1 animate-pulse rounded-t bg-gray-200 dark:bg-white/10"
          [style.height.%]="30 + (bar * 47) % 60"
        ></div>
      }
    </div>
  } @else if (loadState() === 'error') {
    <p role="alert" class="m-0 py-10 text-center text-sm text-error">
      We could not load daily performance.
    </p>
  } @else if (!hasData()) {
    <p class="m-0 py-10 text-center text-sm text-secondary">
      No delivery recorded in this period yet.
    </p>
  } @else {
    <div class="h-56 w-full">
      <app-echart-generic-chart
        [chartOption]="chartOption()"
        [chartXaxisData]="axisLabels()"
        chartVariant="timelineBarPink"
      />
    </div>
  }
</article>
